var _IconClose;
import { Box, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HtmlRenderer from "../../atoms/HtmlRenderer";
import { IconClose } from "../../atoms/Icon";
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import { disableScrollBody } from "../../utils/disableScrollBody";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ModalSelectShipping(props) {
  const {
    open = false,
    onClose,
    title,
    note,
    listCountryShipping,
    description,
    onSelectShipping
  } = props;
  const [selectShipping, setSelectShipping] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      disableScrollBody(!!open);
    }
    if (open) {
      setSelectShipping(false);
    }
  }, [open]);
  const handleCloseModal = () => {
    if (selectShipping) {
      return;
    }
    onClose?.();
  };
  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "auto"
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      },
      onClick: e => {
        e?.stopPropagation();
        handleCloseModal();
      },
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          flexDirection: "column",
          width: {
            xs: "310px",
            md: "478px"
          },
          padding: {
            xs: "56px 28px",
            md: "64px 60px"
          },
          maxWidth: "642px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative"
        },
        onClick: e => {
          e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            position: "absolute",
            top: "16px",
            right: "16px",
            cursor: "pointer"
          },
          onClick: handleCloseModal,
          children: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {
            htmlColor: "#C1C1C1"
          }))
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          color: colors.primary.bandaiNamcoBlack,
          children: title
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            paddingTop: "24px",
            fontSize: {
              xs: "14px",
              md: "16px"
            },
            lineHeight: {
              xs: "20px",
              md: "22px"
            },
            "& strong": {
              fontWeight: "600"
            }
          },
          children: /*#__PURE__*/_jsx(HtmlRenderer, {
            value: note,
            component: "div"
          })
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            paddingTop: "20px"
          },
          children: listCountryShipping?.length && listCountryShipping.map((item, index) => {
            return /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                padding: {
                  xs: "11px 14px",
                  md: "11px 16px"
                },
                cursor: "pointer",
                pointerEvents: selectShipping ? "none" : "auto",
                "&:hover": {
                  background: "#F6F6F6",
                  borderRadius: "4px"
                }
              },
              onClick: () => {
                onSelectShipping?.(item);
                setSelectShipping(true);
              },
              children: [/*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  "& img": {
                    width: "16px",
                    height: "16px"
                  }
                },
                children: [item?.iconCountry && /*#__PURE__*/_jsx("img", {
                  src: item?.iconCountry,
                  alt: ""
                }), item?.name && /*#__PURE__*/_jsx(Typography, {
                  variant: "p6",
                  sx: {
                    marginLeft: "8px"
                  },
                  children: item?.name
                })]
              }), item?.currency && item?.symbol && /*#__PURE__*/_jsx(Typography, {
                variant: "p6",
                sx: {
                  marginLeft: "24px"
                },
                children: `${item?.currency} (${item?.symbol})`
              })]
            }, index);
          })
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "p9",
          color: "#737373",
          sx: {
            paddingTop: "20px",
            fontSize: {
              xs: "10px",
              md: "12px"
            },
            lineHeight: {
              xs: "14px",
              md: "16px"
            }
          },
          children: description
        })]
      })
    })
  });
}